import axiosInstance from ".";

export const signUp = (user) =>
  axiosInstance.post(`/v1/users/signup`,user);

export const verify = (user)  =>
 axiosInstance.post(`/v1/users/verify`,user);
    

export const resetPassword = (resetObj) =>
  axiosInstance.post('/v1/users/reset-password',resetObj);

export const  fetchAccountDetails = () => 
  axiosInstance.get('/v1/users/account')

export const forgotPassword = (forgotpasswordDto) =>
 axiosInstance.post('/v1/users/request-password-reset', forgotpasswordDto);   

export const changePassword = (changePasswordDto) => 
  axiosInstance.post('/v1/users/change-password', changePasswordDto); 

